module.exports = __webpack_public_path__ + "img/restaurant.84f09256.png";